type Props = {
  collapsed?: boolean;
};

export default function ProfileIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="15"
        height="13"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.4)" }}
        className={collapsed ? "" : "relative left-[0px]"}
      >
        <path
          d="M7.125 10.9519C8.50571 10.9519 9.625 9.83262 9.625 8.4519C9.625 7.07119 8.50571 5.9519 7.125 5.9519C5.74429 5.9519 4.625 7.07119 4.625 8.4519C4.625 9.83262 5.74429 10.9519 7.125 10.9519ZM7.125 10.9519C6.29696 10.9519 5.48591 11.1868 4.78603 11.6293C4.08615 12.0718 3.52615 12.7038 3.17107 13.4518L2.125 13.4519C2.04293 13.4519 1.96166 13.4358 1.88583 13.4044C1.81 13.3729 1.7411 13.3269 1.68306 13.2689C1.62502 13.2109 1.57899 13.142 1.54758 13.0661C1.51617 12.9903 1.5 12.909 1.5 12.827V1.5769C1.5 1.41114 1.56585 1.25217 1.68306 1.13496C1.80027 1.01775 1.95924 0.951904 2.125 0.951904H15.875C16.0408 0.951904 16.1997 1.01775 16.3169 1.13496C16.4342 1.25217 16.5 1.41114 16.5 1.5769V12.8269C16.5 12.909 16.4838 12.9903 16.4524 13.0661C16.421 13.1419 16.375 13.2108 16.3169 13.2688C16.2589 13.3269 16.19 13.3729 16.1142 13.4043C16.0383 13.4357 15.9571 13.4519 15.875 13.4519L11.0789 13.4518C10.7238 12.7038 10.1639 12.0718 9.46397 11.6293C8.76409 11.1868 7.95304 10.9519 7.125 10.9519ZM12.75 10.9519H14V3.4519H4V4.7019"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
